import { Component } from '@angular/core';

/**
 * Crédito de plataforma (siempre Inprovider; no depende del branding compile-time).
 * En app privada vive en el header (no solapa grillas/detalle).
 * En layouts públicos: host class `powered-by--page` (esquina inferior).
 * Logo en assets/powered-by/ para no ser reemplazado por overlays de marca (p.ej. TR).
 */
@Component({
	selector: 'app-powered-by',
	templateUrl: './powered-by.component.html',
	styleUrls: ['./powered-by.component.scss'],
	standalone: false,
})
export class PoweredByComponent {
	readonly logoSrc = 'assets/powered-by/logo-inprovider.png';
}
